import { render, staticRenderFns } from "./AddDangerDrawer.vue?vue&type=template&id=551dc106&"
import script from "./AddDangerDrawer.vue?vue&type=script&lang=js&"
export * from "./AddDangerDrawer.vue?vue&type=script&lang=js&"
import style0 from "./AddDangerDrawer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports